/* eslint-disable react-hooks/exhaustive-deps */
import { gql, useLazyQuery } from '@apollo/client';
import { Badge, useDisclosure } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import InsuranceInstitutionNearlyDueModal from '../../components/Modal/InsuranceInstitutionNearlyDueModal';
import useStore from '../../store';
import { useDebounceEffect } from '../form/useDebounceEffect';

const Q_VALIDITY = gql`
	query get {
		getNearlyDueCompanyValidity {
			totalCount
			licenseCount
			licenses {
				company {
					id
					name
					nameKhmer
					logo
				}
				validFrom
				validTo
				separatedLicenseType
				status
			}
			branchCount
			branches {
				khmerName
				latinName
				company {
					id
					name
					nameKhmer
					logo
				}
				validFrom
				validTo
				status
			}
		}
	}
`;

function InsuranceInstitutionBadge() {
	const { t } = useTranslation();
	const { countUnreadNotifications } = useStore((state) => state?.countUnreadNotifications);
	const { isOpen, onOpen, onClose } = useDisclosure();
	const [getValidity, { data }] = useLazyQuery(Q_VALIDITY);

	useDebounceEffect(getValidity, 200, [countUnreadNotifications]);

	return (
		<>
			{parseInt(data?.getNearlyDueCompanyValidity?.totalCount || 0) > 0 && (
				<>
					<Badge zIndex="99" top="2px" left="2px" position="absolute" colorScheme="yellow" fontSize="16px" onMouseDown={onOpen}>
						{parseInt(data?.getNearlyDueCompanyValidity?.totalCount || 0)} {t('Need(s) Renewal')}
					</Badge>
					{isOpen && <InsuranceInstitutionNearlyDueModal data={data?.getNearlyDueCompanyValidity} isOpen={isOpen} onClose={onClose} />}
				</>
			)}
		</>
	);
}

export default InsuranceInstitutionBadge;
